const screens = {
  s: 320,
  m: 768,
  l: 1024,
  xl: 1440
};
const screensToPixels = (input) => Object.fromEntries(
  Object.entries(input).map(([key, value]) => [key, `${value}px`])
);
var screens_default = screens;
export {
  screens_default as default,
  screensToPixels
};
